module.exports = __webpack_public_path__ + "static/media/Bay_Area_Image_-_rounded_corners.c28982e8.png";